import * as React from "react"
import {Box} from "@mui/material";

import ProductsMatcherTargetProduct from "./Product";
import ProductsMatcherTargetActions from "./Actions";


export default function ProductsMatcherTarget({ targetIndex, data, handleChangeIndex, isLoadingMapping}) {
    return <Box sx={{
        width: 1,
        height: 1,
        backgroundColor: 'background.neutral',
        borderRadius: 1,
        py: 5,
        px: 6.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        justifyContent: 'flex-start'
    }}>
        <ProductsMatcherTargetActions
            targetIndex={targetIndex}
            handleChangeIndex={handleChangeIndex}
			isLoadingMapping={isLoadingMapping}
        />

        <ProductsMatcherTargetProduct data={data} />
    </Box>
}